'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import GudiPadwaMiniOffer from '../components/GudiPadwaMiniOffer';
// import JourneyCTA from '@/components/JourneyCTA';
// import HomeBenefits from '@/components/HomeBenefits';
import HomeHeroSection from '@/components/HomeHeroSection';
// import HomeTrustSection from '@/components/HomeTrustSection';
// import HomeKundaliSection from '@/components/HomeKundaliSection';
// import HomeWorldMapSection from '@/components/HomeWorldMapSection';

export default function Home() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  // Temporarily hidden with the "Ready to get Married?" video.
  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection />

      <HomeLandingSections />

      {/* Temporarily hidden: Verified trust badge, Horoscope & Kundali, Handpicked for you */}
      {/* <HomeTrustSection /> */}
      {/* <HomeKundaliSection /> */}
      {/* <HomeWorldMapSection /> */}

      {/* Quick Search Section - Temporarily hidden until more profiles are available */}
      {/*
      <section className="py-16 bg-white">
        <div className="w-full bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">Quick Search</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 items-end">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Gender</label>
                  <select className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary-100 focus:border-primary-500 transition-all duration-300">
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Age From</label>
                  <input
                    type="number"
                    placeholder="18"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary-100 focus:border-primary-500 transition-all duration-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Age To</label>
                  <input
                    type="number"
                    placeholder="35"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary-100 focus:border-primary-500 transition-all duration-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Religion</label>
                  <select className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary-100 focus:border-primary-500 transition-all duration-300">
                    <option value="">Select Religion</option>
                    <option value="hindu">Hindu</option>
                    <option value="muslim">Muslim</option>
                    <option value="christian">Christian</option>
                    <option value="sikh">Sikh</option>
                    <option value="buddhist">Buddhist</option>
                    <option value="jain">Jain</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <button className="w-full bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300">
                    Search Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* Female Members Promotional Offer Section temporarily hidden for Gudi Padwa campaign */}

      {/* Temporarily hidden: Benefits to Marathi grooms & brides on registration */}
      {/* <HomeBenefits title="Benefits to Marathi grooms & brides on registration:" /> */}

      {/* Gudi Padwa mini offer on homepage */}
      {/* <GudiPadwaMiniOffer /> */}

      {/* Temporarily hidden: video from "Ready to get Married?"
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Ready to get Married?
          </h2>
          <div className="max-w-5xl mx-auto">
            <div className="relative w-full max-w-4xl mx-auto bg-gray-900 rounded-xl overflow-hidden shadow-2xl">
              <div className="relative w-full h-0 pb-[56.25%] bg-black">
                <iframe
                  src="https://www.youtube.com/embed/qojEvStgpNk?rel=0&modestbranding=1&showinfo=0&controls=1&mute=1&loading=lazy"
                  title="Marathi Vadhu Var Suchak Promo Video"
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* FAQ Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How does Marathi Vadhu Var Suchak ensure profile authenticity?",
                  answer: "Marathi Vadhu Var Suchak has a multi-step verification process including photo verification and phone number verification through OTP to ensure all profiles are genuine."
                },
                {
                  question: "Is my personal information data safe on Marathi Vadhu Var Suchak?",
                  answer: "Absolutely! Marathi Vadhu Var Suchak uses enterprise-grade security measures and never shares your personal information with third parties. You have complete control over your Marathi matrimony profile visibility."
                },
                {
                  question: "How long does it take to find an Anuroop Vadhu Var?",
                  answer: "The time varies for each Marathi community Vadhu Var. Some find their Marathi Jeevansathi within weeks, while others may take a few days or months. Our advanced matching algorithm helps speed up the process."
                },
                {
                  question: "Can I control who sees my profile?",
                  answer: "Yes! Marathi Vadhu Var has complete control over your profile visibility. Marathi Vadhu Var can choose who can see your profile and can block or report any unwanted contacts."
                },
                {
                  question: "What makes Marathi Vadhu Var Suchak different from other platforms?",
                  answer: "Marathi Vadhu Var Suchak focuses specifically on Marathi culture and values, has strict verification processes, and provides personalized support throughout your journey to finding the Anuroop Jodidar."
                },
                {
                  question: "Which Marathi community Vadhu Var profiles could be found here?",
                  answer: "Marathi Vadhu Var Suchak is for all Marathi communities. Below are a few examples of Marathi communities:",
                  communities: [
                    "Maratha Vadhu Var",
                    "96 Kuli Maratha Vadhu Var (Including 96 Kuli Maratha surname list)",
                    "Deokar Maratha Vadhu Var",
                    "Kokanastha Maratha Vadhu Var - For e.g. Tawde Vivah",
                    "Brahmin Vadhu Var",
                    "Mali Vadhu Var",
                    "Dhangar Vadhu Var",
                    "Vanjari Vadhu Var",
                    "Veershaiv Vadhu Var",
                    "Dhor Kakkayya Caste Vadhu Var",
                    "Kunbi Caste Vadhu Var",
                    "Matang Vadhu Var",
                    "Leva Patil Vadhu Var",
                    "Lingayat Caste Vadhu Var",
                    "Bhandari Vadhu Var",
                    "Buddhist Vadhu Var"
                  ]
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                      {faq.communities && (
                        <ul className="list-disc list-inside space-y-1 ml-4">
                          {faq.communities.map((community, idx) => (
                            <li key={idx} className="text-gray-600">{community}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Temporarily hidden: Ready to Start Your Journey?
      <JourneyCTA
        title="Ready to Start Your Journey?"
        description="Discover meaningful connections through our trusted Marathi matrimony platform built with the Marathi community's values at heart"
        primaryButtonText="Register Now in 2 minutes"
        primaryButtonLink="/register"
      />
      */}

      <CommunityMatrimonyServices />

    </div>
  );
}
